export default {
  taskRecord: {
    title: "ٹاسک انعامات",
    loading: "لوڈ ہو رہا ہے...",
    empty: "کوئی انعام نہیں",
    completed: "یہ ٹاسک مکمل ہو چکا ہے",
    desc: "ٹاسک مکمل کریں اور انعام حاصل کریں",
    close: "بند کریں",
    add: "شامل کریں",
    addEmail: "ای میل شامل کریں",
    addPhoneNumber: "فون نمبر شامل کریں",
    addBirthday: "سالگرہ شامل کریں",
    downloadNow: "ابھی ڈاؤن لوڈ کریں",
    phone: "فون نمبر",
    email: "ای میل ایڈریس",
    bank: "بینک کارڈ",
    birthday: "سالگرہ",
    download: "ڈاؤن لوڈ",
    downloadApp: "APP ڈاؤن لوڈ کریں",
    registerBonus: "رجسٹریشن بونس",
    firstInviteBonus: "پہلی دعوت بونس",
    invite: "دعوت دیں",
    inviteNow: "دوستوں کو مدعو کریں",
    go: "جائیں",
    receive: "حاصل کریں",
    received: "حاصل ہو چکا",
    task: "ٹاسک",
	claimRewards: 'انعامات کا دعویٰ کریں',
    receiveSuccess: 'انعام کامیابی سے حاصل ہو گیا',
    receiveFail: 'انعام حاصل کرنے میں ناکامی'
  }
};
